import { render } from "./AppMainShell.vue?vue&type=template&id=329bf1ca&scoped=true"
import script from "./AppMainShell.vue?vue&type=script&lang=js"
export * from "./AppMainShell.vue?vue&type=script&lang=js"

import "./AppMainShell.vue?vue&type=style&index=0&id=329bf1ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329bf1ca"]])

export default __exports__